import React from 'react';
import classNames from 'classnames';

import chevronDownIcon from '../../../assets/search/icon-chevron-down.svg';

import css from './PopupOpenerButton.module.css';

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const {
    isSelected = false,
    labelMaxWidth = null,
    toggleOpen,
    children,
    variant,
    showChevron = true,
    ...rest
  } = props;

  const isPill = variant === 'pill';
  const labelStyles = isPill
    ? classNames(css.pill, { [css.pillSelected]: isSelected })
    : isSelected
    ? css.labelSelected
    : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      className={classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
      {...rest}
    >
      {children}
      {isPill && showChevron ? (
        <img className={css.pillChevron} src={chevronDownIcon} alt="" width={20} height={20} />
      ) : null}
    </button>
  );
};

export default PopupOpenerButton;
